import { render, staticRenderFns } from "./TagSearch.vue?vue&type=template&id=45de94df&scoped=true&"
import script from "./TagSearch.vue?vue&type=script&lang=js&"
export * from "./TagSearch.vue?vue&type=script&lang=js&"
import style0 from "./TagSearch.vue?vue&type=style&index=0&id=45de94df&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de94df",
  null
  
)

export default component.exports